import { getCommunities } from 'src/client'
import { useInfiniteRequest } from 'src/hook/useInfinityRequest'
import { COMMUNITIES_PER_PAGE, REQUEST_CONFIG } from './useListCommunities.constants'
import { UseListCommunitiesProps } from './useListCommunities.types'

const useListCommunities = ({
  membership,
  communitiesPerPage = COMMUNITIES_PER_PAGE,
  nextPageToken = ''
}: UseListCommunitiesProps) => {
  const { cacheTime, staleTime } = REQUEST_CONFIG
  const cacheKey = `membership:${membership}-rows:${communitiesPerPage}-nextPageToken:${nextPageToken}`

  /* istanbul ignore next */
  const fetchData = async ({ pageParam = '' }) => {
    const data = await getCommunities(membership, pageParam, communitiesPerPage)

    return data
  }

  return useInfiniteRequest(['getCommunities', cacheKey], fetchData, {
    enabled: Boolean(membership),
    cacheTime,
    staleTime,
    getNextPageParam: /* istanbul ignore next */ (lastPage) => {
      return lastPage?.nextPageToken
    }
  })
}

export default useListCommunities
